import {styled} from "@mui/material/styles"

export const StyledStandardSingleFacetCountWrapper = styled("span")<{$isDisabled?: boolean}>`
    ${({theme, $isDisabled}) => $isDisabled && `color: ${theme.colours.text.disabled}`};
    overflow: hidden;
    text-overflow: ellipsis;
`
